import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControl,
  Accordion as MuiExpansionPanel,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import {
  DateRange as DateRangeIcon,
  PhoneDisabled as PhoneDisabledIcon,
} from "@material-ui/icons";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

//store
import * as actions from "../../../../store/actions/actionIndex";
//import RecentLeadBucket from "../Preview/RecentLeadBucket";
import PreviousComments from "./PreviousComments";
import { useLoader } from "../../../../context/LoaderContext";
import Loading from "../../../Loading";
import { toast } from "react-toastify";
import { localStorageFunc, notify } from "../../../../helpers/utility";
import CustomConfirmDialog from "../../../../helpers/ConfirmDialogue";
import axios from "axios";
import { error } from "highcharts";

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const callStatusArr = [
  {
    value: "Answered",
    label: "Answered",
  },
  {
    value: "DNC",
    label: "DNC",
  },
];

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      // width: 200,
    },
  },
  label: {
    padding: "0",
    width: "100%",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.5px",
    color: "#686D88",
  },
  DispositionTitle: {
    color: "white",
    backgroundColor: "#242a5a",
    fontSize: "15px",
    lineHeight: "18px",
    marginBottom: -1,
    padding: "16px 25px 16px 24px",
    minHeight: 40,
    "&$expanded": {
      minHeight: 40,
    },
  },
  DispositionGridItem: {
    margin: "5px 0",
    backgroundColor: "white",
    paddingInlineStart: "10px",
    width: "100%",
  },
  NextCallTime: {
    flex: "1 0 33%",
    maxWidth: "33%",
    alignItems: "center",
  },
  Commentfield: {
    color: "#343A58",
    boxSizing: "border-box",
    borderRadius: "4px",
    margin: "8px 0 !important",
    fontSize: "12px",
  },
  SubmitButton: {
    backgroundColor: "white",
    textTransform: "capitalize",
    width: "127px",
    border: "0.5px solid blue",
  },
  LastButton: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textfield: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#343A58",
    boxSizing: "border-box",
    borderRadius: "4px",
    margin: "8px 0 !important",
    paddingBlock: "0px",
    paddingInlineEnd: "10px",
    paddingInlineStart: "0px",
  },
  Button: {
    paddingBottom: "25px",
    marginTop: "25px",
    [theme.breakpoints.down("xs")]: {
      paddingBottom: "0px",
    }
  },
  Date: {
    marginTop: "0px",
  },
  DateSelect: {
    marginBlock: "8px",
    marginInlineStart: "0px",
    marginInlineEnd: "10px",
    padding: "0px 15px",
    height: "40px",
    border: "1px solid rgba(0,0,0,0.2)",
    borderRadius: "3px",
    outline: "none !important",
    width: "108%",
  },

  "@keyframes blink": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0 },
    "100%": { opacity: 1 },
  },

  blinkingCheckbox: {
    animation: "$blink 1s infinite",
  },
}));

const currentTimeGMT = (gmtTime, operation, strdiff) => {
    let d;
    if (!isNaN(gmtTime)) {
      d = new Date(gmtTime * 1000);
    } else {
      d = new Date(gmtTime);
      if (isNaN(d.getTime())) {
        throw new Error('Invalid date format');
      }
    }
  // let offset = d.getTimezoneOffset() * 60000;
  // console.log(offset);
  // if (operation === "sum") {
  //   d.setTime(d.getTime() + strdiff * 1000);
  // } else {
  //   d.setTime(d.getTime() - strdiff * 1000);
  // }

  // // d.setTime(d.getTime() + offset);
  return d;
  
};

const currentTime = (d, gmtTime) => {
  d.setTime(d.getTime() + gmtTime * (gmtTime === 1 ? 10000 : 60000));
  let fullYear = d.getFullYear();
  let fullMonth = d.getMonth() + 1;
  fullMonth = fullMonth < 10 ? "0" + fullMonth : fullMonth;
  let fullDay = d.getDate();
  fullDay = fullDay < 10 ? "0" + fullDay : fullDay;
  let fullHours = d.getHours();
  fullHours = fullHours < 10 ? "0" + fullHours : fullHours;
  let fullMinutes = d.getMinutes();
  fullMinutes = fullMinutes < 10 ? "0" + fullMinutes : fullMinutes;
  return {
    year: fullYear,
    month: fullMonth,
    day: fullDay,
    hour: fullHours,
    min: fullMinutes,
  };
};

function Disposition(props) {
  const [state, setState] = useState({ feedbackFlag: 0, checkedB: 0 });
  const [callStatus, setCallStatus] = useState("Answered");
  const [category, setCategory] = useState("Not_Assigned");
  const [subDisp, setSubDisp] = useState("Not_Assigned");
  const [oldValues, setOldValues] = useState("");
  const [comment, setComment] = useState("");
  const [startDate, setStartDate] = useState();
  const [shouldDisconnect, setShouldDisconnect] = useState(false);
  const [callTime, setCallTime] = useState("");
  //Client speicific
  const [showFeedback, setShowFeedback] = useState("NO");
  


  // const [currentVal, setCurrentVal] = useState(props.currentGmtTime === "" || props.currentGmtTime === undefined ? timestamp + 19800 : props.currentGmtTime)
  const componentId1 = 'EndCall';
  const componentId2 = 'Disconnect';
  const componentId3 = 'Save';
  
  const { loading: loading1, showLoader: showLoader1 } = useLoader(componentId1);
  const { loading: loading2, showLoader: showLoader2 } = useLoader(componentId2);
  const { loading: loading3, showLoader: showLoader3 } = useLoader(componentId3);

const [dialogOpen, setDialogOpen] = useState(false);
const [confirmCallback, setConfirmCallback] = useState(null);

const handleConfirm = () => {
  setDialogOpen(false);
};

const handleCancel = () => {
 
  if (confirmCallback) {
    confirmCallback();
  }
  setDialogOpen(false);
};


  let nextCallAction = "DialerDialToAnyone";

  if (
    props.previewDialing === "ENABLED" &&
    props.campConf.callback_options === "0" &&
    props.dialerType === "PREVIEW"
  ) {
    nextCallAction = "PreviewCall";
  } else if (
    props.previewDialing === "ENABLED" &&
    props.campConf.next_action_on_lead === "preview"
  ) {
    nextCallAction = "PreviewCall";
  } else if (
    props.campConf.callback_options === "0" &&
    (props.dialerType === "PROGRESSIVE" || props.dialerType === "PREDICTIVE")
  ) {
    nextCallAction = "DialerDialToAnyone";
  } else if (
    props.nextActionOnLead === "dda" ||
    (props.campConf.next_action_on_lead === "preview" && props.previewDialing !== "ENABLED")
  ) {
    nextCallAction = "DialerDialToAnyone";
  } else if (
    props.campConf.callback_options === "1" &&
    props.campConf.next_action_on_lead === "ddm"
  ) {
    nextCallAction = "DialerDialToMyself";
  }
  const [nextAction, setNextAction] = useState(nextCallAction);

  var classes = useStyles();

  const dispositionRadio = (event) => {
    setNextAction(event.target.value);
  };
  const { agentId, onGetDisposition } = props;
 
  useEffect(() => {
    const phoneEntries = Object.entries(props.crmValues)
      .filter(([key]) => /\.phone\d+$/.test(key))
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
      setOldValues(phoneEntries)
  }, [props.crmValues]);

     useEffect(() => {
  onGetDisposition(agentId);
}, [agentId, onGetDisposition, props.currentGmtTime]);

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked ? 2 : 0 });
  };

  // Reset this
  useEffect(() =>{
    if(props.agentState !== "INCALL"){
      setState({...state, feedbackFlag: 0})
    }
  },
  [props.agentState])

  useEffect(() => {

    setNextCallTime(category, subDisp);
  }, [props.currentGmtTime, category, subDisp]);
  

  const handleComment = (value) => {
    if (
      (!value.match(/[^0-9a-zA-Z.!@&_=+:,?;|()#%/\s\\-]+/g) &&
        value.length < 256) ||
      value === ""
    ) {
      setComment(value);
    } else {
      alert(
        "Only following special character allowed with maximum length 255.\n ! @ & - _ = + : , . ? ; / | ( ) # % \\"
      );
    }
  };
  useEffect(() => {
    setCategory("Not_Assigned");
    setSubDisp("Not_Assigned");
  }, [props.custPhone]);

  const handleCategory = (value) => {
    setCategory(value);
  if(value === "Not_Assigned"){
    setSubDisp("Not_Assigned");
  }
  else {
    for (const key in props.dispositions[value]) {
      setSubDisp(key);
      setNextCallTime(value);
      break;
    }
  }
  };
  const handleDisposition = (catValue, value) => {
    setSubDisp(value);
    setNextCallTime(catValue, value);
  };

  const setNextCallTime = (catValue, value) => {
    if (props.dispositions && props.dispositions[catValue] && props.dispositions[catValue][value]){
    let nct = props.dispositions[catValue][value];
    let JSO = props.jsOperation ==="" || props.jsOperation === undefined ? "sum" : props.jsOperation;
    let TDF = props.timeDiff === "" || props.timeDiff === undefined ? 0 : props.timeDiff;
    if (nct && nct !== "" && nct !== "0") {
      let timestamp = Date.now() || +new Date();
      timestamp = Math.floor(timestamp / 1000);
      let currentGmtTime = props.currentGmtTime === "" || props.currentGmtTime === undefined ? timestamp + 19800 : props.currentGmtTime;
      let gmtTime = currentTimeGMT(
        currentGmtTime,
        JSO,
        TDF
      );
      let currTime = currentTime(gmtTime, nct);

      setStartDate(
        new Date(
          currTime.year +
            "-" +
            currTime.month +
            "-" +
            currTime.day +
            " " +
            currTime.hour +
            ":" +
            currTime.min
        )
      );
    } else {
      setStartDate();
    }
  }
  else{
  setStartDate();
  }
  };

  const setDateTime = (d) => {
   let timestamp = Date.now() || +new Date();
      timestamp = Math.floor(timestamp / 1000);
   let currentGmtTime = props.currentGmtTime === "" || props.currentGmtTime === undefined ? timestamp + 19800 : props.currentGmtTime;
    var userdt = new Date(d);
    var currdt = new Date(currentGmtTime);
    if (userdt < currdt) {
      alert("Next Call Time must be greater than the current date time.");
    } else {
      setStartDate(d);
    }
  };


  const formatDateTime = (date) => {
    if (!date) return "";
  
    const fullYear = date.getFullYear();
    const fullMonth = String(date.getMonth() + 1).padStart(2, '0');
    const fullDay = String(date.getDate()).padStart(2, '0');
    const fullHours = String(date.getHours()).padStart(2, '0');
    const fullMinutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${fullYear}-${fullMonth}-${fullDay} ${fullHours}:${fullMinutes}:00`;
  };
  
  const CrmValues = () => {
    const matchWithDisp = localStorageFunc.get("matchWithDisp");
    const getDispValue = matchWithDisp !== null ? JSON.parse(matchWithDisp) : null;
  
    if (getDispValue) {
      const crmValues = localStorageFunc.get("crmValues");
      const crmValuesData = crmValues !== null ? JSON.parse(crmValues) : {};
  
      const dispositionKeys = getDispValue.disposition.split(',');
      const subDispKey = getDispValue.subDisp;
      const dispositionValues = dispositionKeys
        .map(key => crmValuesData[key])
        .filter(value => value && value !== 'Select')
        .join('###');
      
      const subDispValue = crmValuesData[subDispKey] || null;

      return { dispositionValues, subDispValue };
    }
  
    return { dispositionValues: '', subDispValue: '' };
};

const combineDispositionValues = (category, dispositionValues, subDisp, subDispValue) => {
  let combinedDisposition = category;
  let combinedsubDisp = subDisp;

  if (dispositionValues && dispositionValues !== 'Select') {
    combinedDisposition = `${category}###${dispositionValues}`;
  }

  if (subDispValue && subDispValue !== 'Select') {
    combinedsubDisp = `${subDisp}###${subDispValue}`;
  }
console.log(combinedDisposition, combinedsubDisp)
  return { combinedDisposition, combinedsubDisp };
};

  const saveDisposition = () => {
    const { dispositionValues, subDispValue } = CrmValues();  
    showLoader3();
  
    if (startDate) {
      const formattedDate = formatDateTime(startDate);
      setCallTime(formattedDate);
    }
    const { combinedDisposition, combinedsubDisp } = combineDispositionValues(
      category,
      dispositionValues,
      subDisp,
      subDispValue
    );
  
    // Call props.onSetDisposition with the updated values
    props.onSetDisposition(
      props.agentId,
      combinedDisposition,
      combinedsubDisp,
      comment,
      formatDateTime(startDate),
      props.actionOriginate,
      props.confLeadId
    );
    props.onResetDisposition(props.agentId);
  };
  
  

  const handleDisconnect = async () => {
    const storedMandatoryFlag = localStorageFunc.get("mandatoryFlag");
    const missingFields = JSON.parse(localStorageFunc.get("missingFields") || "[]");
    const GetFieldsData = JSON.parse(localStorageFunc.get("crmValues"));
    showLoader1();
    if (!props.disconnectLoading) {
      if (startDate) {
        const formattedDate = formatDateTime(startDate);
        setCallTime(formattedDate);
      }
      const { dispositionValues, subDispValue } = CrmValues(); 
  
      setSubDisp(prevSubDisp => {

        if (props.mandatoryDisp === "1" && prevSubDisp === "Not_Assigned") {
          toast.error("Disconnect Error: You have missed to set the disposition.", {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        if (
          (props.mandatoryDisp === "1" && prevSubDisp !== "Not_Assigned") ||
          (props.mandatoryDisp === "0" || props.mandatoryDisp === undefined)
        ) {
          const { combinedDisposition, combinedsubDisp } = combineDispositionValues(
            category,
            dispositionValues,
            subDisp,
            subDispValue
          );
          if (storedMandatoryFlag === "0" || storedMandatoryFlag === null ) {
            if (!GetFieldsData || (typeof GetFieldsData === 'object' && Object.keys(GetFieldsData).length === 0)) {
                props.onSetDisposition(
                  props.agentId,
                  combinedDisposition, 
                  combinedsubDisp, 
                  comment,
                  formatDateTime(startDate),
                  props.actionOriginate,
                  props.confLeadId,
                );
                setShouldDisconnect(true);
            } else {
              props.onCustomerDetails(
                props.agentId,
                props.campaignId,
                props.leadId,
                GetFieldsData,
                oldValues,
              );
              props.onSetDisposition(
                props.agentId,
                combinedDisposition,
                combinedsubDisp,
                comment,
                formatDateTime(startDate),
                props.actionOriginate,
                props.confLeadId,
              );
              setShouldDisconnect(true);
            }
          } else {
            notify(`CRM Error: Please fill the following mandatory fields: ${missingFields[0]}.`, "crm-error");
          }
        }
  
        return prevSubDisp;
      });
    }
  };

  useEffect(() => {
    try {
      console.log(shouldDisconnect, props.statusDisp);
      if (shouldDisconnect && props.statusDisp === "SUCCESS") {
        props.onAgentDisconnect(
          props.agentId,
          state.feedbackFlag,
          callStatus,
          nextAction,
          "callDisconnect",
          props.phType,
          comment,
          category,
          subDisp,
          callTime,
          "0"
        );
        props.onResetDisposition(props.agentId);
        setShouldDisconnect(false);
      }
    } catch (error) {
      console.error("Error during agent disconnect:", error);
    }
  }, [shouldDisconnect, props.statusDisp]);
  
  
  useEffect(() => {
    let intervalId;
    try{
   console.log(props.agentState, props.wrpupDisconnectFlag)
    if ((props.agentState === "CLOSURE" || props.agentState === "PREVIEW_FAIL") && props.wrpupDisconnectFlag === "1" && props.wrapTime !== "0") {   
      
      intervalId = setInterval(() => {
        const formattedDate = formatDateTime(startDate);
        const feedbackFlag = state.feedbackFlag;
        const { dispositionValues, subDispValue } = CrmValues(); 
        const { combinedDisposition, combinedsubDisp } = combineDispositionValues(
          category,
          dispositionValues,
          subDisp,
          subDispValue
        );
        props.onSetDisposition(
          props.agentId,
          combinedDisposition,
         combinedsubDisp,
          comment,
          formatDateTime(startDate),
          props.actionOriginate,
          props.confLeadId,
        );
        props.onAgentDisconnect(
          props.agentId,
          feedbackFlag,
          callStatus,
          nextAction,
          "callDisconnect",
          props.phType,
          comment,
          category,
          subDisp,
          formattedDate,
          "1"
        );
      }, props.wrapTime * 1000);
      props.onResetDisposition(props.agentId);
    }
    }
    catch (error) {
      console.error("Error during agent disconnect:", error);
    }
    return () => clearInterval(intervalId);
  
  }, [props.agentState, state.feedbackFlag, props.wrpupDisconnectFlag, startDate,category, subDisp ]);


  
  const handleCustomerDisconnect = () => {
    showLoader2();
    if (!props.disconnectLoading) {
      props.onAgentTelDisconnect(
        props.agentId,
        state.feedbackFlag,
        "customerDisconnect",
      );
    }
  };
  
  // call feedback external API
  useEffect(() => {
    const callCount = localStorageFunc.get("callCount");
    if (window.Configs.feedback_check === 1 && callCount !== '0') {
      axios
        .post(
          window.Configs.feeBack_url,
          JSON.stringify({
            count: callCount,
            agent_id: props.agentId,
          }),
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          setShowFeedback(response.data.message);
        })
        .catch((error) => {
          console.error("Error fetching feedback:", error);
        });
    } else {
      setShowFeedback("Yes");
    }
  }, [window.Configs.feedback_check]);
  

// Dispose the call

useEffect(() => {
  if (props.triggerDisconnect) {
    handleDisconnect(); 
    props.onDisconnectHandled(); 
  }
}, [props.triggerDisconnect]);

  return (
    <Grid
      className={classes.DispositionGrid}
      item
      xs={false}
      md={false}
      lg={false}
    >
      <Accordion>
        <Typography className={classes.DispositionTitle}>
          Disposition
          <span
            style={{
              position: "absolute",
              top: "9px",
              insetInlineEnd: "25px",
              display: "flex",
            }}
          >
            {props.leadId && props.leadId !== "0" && (
              <PreviousComments leadId={props.leadId} />
            )}
            {/*<RecentLeadBucket leadId={props.leadId} /><ChangeLog />*/}
          </span>
        </Typography>
      </Accordion>
      <Grid className={classes.DispositionGridItem} container spacing={1}>
       
{/* <CustomConfirmDialog
  open={dialogOpen}
  onConfirm={handleConfirm}
  onCancel={handleCancel}
  message="The CRM field has not been updated. Would you like to make changes?"
/> */}

<Grid item md={4} xs={12} lg={4}>
  <label className={classes.label}>DISPOSITION</label>
  <TextField
    className={classes.textfield}
    fullWidth
    margin="dense"
    name="category"
    id = "category"
    value={category || ''}
    onChange={(e) => handleCategory(e.target.value)}
    required
    select
    SelectProps={{ native: true }}
    placeholder="Select"
    variant="outlined"
  >
    <option key={0} value="Not_Assigned">
      Select
    </option>
    {Object.keys(props.dispositions).length === 1 && "Not_Assigned" in props.dispositions ? null : (
      Object.entries(props.dispositions).map(([key, value]) => (
        <option key={key} value={key}>
          {key.replace(/_/g, " ")}
        </option>
      ))
    )}
  </TextField>
</Grid>

    
        <Grid item md={4} xs={12} lg={4}>
          <label className={classes.label}>SUB DISPOSITION</label>

      <TextField
            className={classes.textfield}
            select
            fullWidth
            margin="dense"
            name="subDisposition"
            id = "subDisposition"
            value={subDisp || ''}
            onChange={(e) => handleDisposition(category, e.target.value)}
            required
            SelectProps={{ native: true }}
            placeholder="Select"
            variant="outlined"
          >
            <option key={0} value="Not_Assigned">
              Select
            </option>
            {props.dispositions[category] &&
              Object.entries(props.dispositions[category]).map(
                ([key, value]) => (
                  <option key={key} value={key}>
                    {key.replace(/_/g, " ")}
                  </option>
                )
              )}
          </TextField>
        </Grid>
        <Grid item md={4} xs={12} lg={4}>
          <label className={classes.label}>CALL STATUS</label>
          <TextField
            className={classes.textfield}
            fullWidth
            margin="dense"
            name="callStatus"
            id = "callStatus"
            onChange={(e) => setCallStatus(e.target.value)}
            required
            select
            SelectProps={{ native: true }}
            placeholder="Select"
            variant="outlined"
          >
            {callStatusArr.map((option) => (
              <option
                key={option.value}
                value={option.value}
                checked={callStatus}
              >
                {option.label}
              </option>
            ))}
          </TextField>
        </Grid>
        { props.dispositions[category] && startDate && props.leadId &&
        props.leadId !== "0" &&
        props.actionOriginate !== "conference" ? (
          <Grid container style={{ alignItems: "baseline" }} spacing={1}>
            <Grid item md={4} xs={12} lg={4}>
              <label className={classes.label}>NEXT CALL DATE</label>
              <div className={classes.Date}>
                <DatePicker
                  id="next_call_date"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="scroll"
                  isClearable
                  placeholder={<DateRangeIcon />}
                  selected={startDate}
                  minDate={new Date()}
                  timeIntervals={15}
                  onChange={(date) => setDateTime(date)}
                  showTimeSelect
                  fixedHeight
                  dateFormat="yyyy-MM-dd HH:mm"
                  autocomplete="off"
                  className={classes.DateSelect}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        <Grid container spacing={1}>
          <Grid item xs={8}>
            <label className={classes.label}>COMMENTS</label>
            <TextField
              fullWidth
              id="outlined-textarea"
              className={classes.Commentfield}
              margin="dense"
              multiline
              variant="outlined"
              value={comment}
              onChange={(e) => handleComment(e.target.value)}
            />
          </Grid>
        </Grid>
        {startDate && (props.campaignDialerType === "PROGRESSIVE" ||
          props.campaignDialerType === "PREDICTIVE") &&
        props.actionOriginate !== "conference"
         ? (
          <Grid container spacing={1}>
            <FormControl component="fieldset">
              <RadioGroup row value={nextAction} onChange={dispositionRadio}>
                <FormControlLabel
                  value="PreviewCall"
                  control={<Radio />}
                  label="Preview Call"
                />
                <FormControlLabel
                  value="DialerDialToAnyone"
                  control={<Radio />}
                  label="Dialer Dial To Anyone"
                />
                <FormControlLabel
                  value="DialerDialToMyself"
                  control={<Radio />}
                  label="Dialer Dial To Myself"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        ) : (
          ""
        )}
   {window.Configs.feedback_check !== 1  ? (
  props.campConf.agent_feedback === "1" &&
  props.agentState === "INCALL" && (
  props.campConf.feedback_for_camp_type !== "BLENDED"
    ? props.callType === props.campConf.feedback_for_camp_type
    : true
)  &&
  props.actionOriginate !== "conference" ? (
    <div>
      <Grid container spacing={1}>
        <FormControlLabel
          control={
            <GreenCheckbox
              checked={state.feedbackFlag}
              onChange={handleChange("feedbackFlag")}
              value={state.feedbackFlag}
              
            />
          }
          label="Transfer for feedback"
        />
      </Grid>
    </div>
  ) : ''
) : (
  props.campConf.agent_feedback === "1" &&
  props.agentState === "INCALL" &&
  props.actionOriginate !== "conference" && (
  props.campConf.feedback_for_camp_type !== "BLENDED"
    ? props.callType === props.campConf.feedback_for_camp_type
    : true
)  && showFeedback === "Yes"? (
    <div>
      <Grid container spacing={1}>
        <FormControlLabel
          control={
            <GreenCheckbox
              checked={state.feedbackFlag}
              onChange={handleChange("feedbackFlag")}
              value={state.feedbackFlag}
              
            />
          }
          label="Transfer for feedback"
        />
      </Grid>
    </div>) :
    ''
)}



        <Grid container spacing={1} className={classes.LastButton}>
          <Grid item md={4} xs={12} lg={"auto"}>
            <div className={classes.Button}>
              {props.loading ? (
                <CircularProgress size={34} />
              ) : (
                loading3 ? <Loading /> :
                <Button
                  className={classes.SubmitButton}
                  variant="contained"
                  onClick={saveDisposition}
                  style={{
                    marginInlineStart: "0",
                    textTransform: "capitalize",
                    padding: "5px 10px",
                  }}
                >
                  Set Disposition
                </Button>
              )}
            </div>
          </Grid>
          {props.actionOriginate !== "conference" ? (
            <>
              <Grid item md={4} xs={12} lg={"auto"}>
                <div className={classes.Button}>
                  {props.facilityConf.disable_disconnect_incall === "1" ? (
                    ""
                  ) : props.agentState === "INCALL" ? (
                    props.loading ? (
                      <CircularProgress size={34} />
                    ) :  (
                      loading2 ? <Loading /> :
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        style={{ marginInlineEnd: "10px", border: "2px solid" }}
                        onClick={handleCustomerDisconnect}
                      >
                        <PhoneDisabledIcon color="secondary" />
                        &nbsp;Disconnect Customer
                      </Button>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </Grid>
              <Grid item md={4} xs={12} lg={"auto"}>
                <div className={classes.Button}>
                  {props.facilityConf.disable_disconnect_incall === "1" ? (
                    ""
                  ) : props.agentState === "INCALL" ||
                    props.agentState === "CLOSURE" ||
                    props.agentState === "PREVIEW_FAIL" ? (
                    props.loading ? (
                      <CircularProgress size={34} />
                    ) : (
                      loading1 ? <Loading /> :
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        style={{ marginInlineEnd: "10px", border: "2px solid" }}
                        onClick={handleDisconnect}
                      >
                        <PhoneDisabledIcon color="secondary" />
                        &nbsp;End Call
                      </Button>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    error: state.callDisp.error,
    loading: state.callDisp.loading,
    disconnectError: state.agentDisconnect.error,
    disconnectLoading: state.agentDisconnect.loading,
    dispositions: state.callDisp.dispositions,
    currentGmtTime: state.callDisp.currentGmtTime,
    jsOperation: state.callDisp.jsOperation,
    timeDiff: state.callDisp.timeDiff,
    custPhone: state.agentData.custPhone,
    mandatoryDisp: state.agentData.mandatory,
    leadId: state.agentData.leadId,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    facilityConf: state.agentConfig.facilityConf,
    callDuration: state.agentData.callDuration,
    campConf: state.agentConfig.campConf,
    statusDisp : state.callDisp.status,
    nextActionOnLead: state.agentData.nextActionOnLead,
    crmValues: state.customerDetails.crmValues,
    dialerType: state.agentData.dialerType,
    campaignDialerType: state.agentData.campaignDialerType,
    previewDialing: state.agentData.previewDialing,
    wrapTime: state.agentData.wrapTime,
    lastActivityTime: state.agentData.lastActivityTime,
     callType: state.agentData.callType,
    wrpupDisconnectFlag: state.agentData.wrpupDisconnectFlag,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDisconnect: (
      agentId,
      feedbackFlag,
      callStatus,
      nextAction,
      actionType,
      phType,
      comment,
      category,
      disposition,
      nextCallTime,
      auto_wrapped
    ) =>
      dispatch(
        actions.agentDisconnect(
          agentId,
          feedbackFlag,
          callStatus,
          nextAction,
          actionType,
          phType,
          comment,
          category,
          disposition,
          nextCallTime,
          auto_wrapped
        )
      ),
     onAgentTelDisconnect: (
        agentId,
        isFeedback,
        actionType,
     ) =>
      dispatch(
        actions.agentTelDisconnect(
          agentId,
          isFeedback,
          actionType,
        )
      ),
    onGetDisposition: (agentId) => dispatch(actions.getDisposition(agentId)),
    onSetDisposition: (
      agentId,
      category,
      subDisp,
      remarks,
      nextCallTime,
      actionOriginate,
      confLeadId,   
    ) =>
      dispatch(
        actions.setDisposition(
          agentId,
          category,
          subDisp,
          remarks,
          nextCallTime,
          actionOriginate,
          confLeadId,
        )
      ),
      onCustomerDetails: (agentId, campaignId, leadId, setValues, oldValues) =>
        dispatch(actions.customerDetails(agentId, campaignId, leadId, setValues, oldValues)),
      onResetDisposition: (agentId) => dispatch(actions.setDispositionReset(agentId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Disposition);
